/**
 * Filter Tags View
 * @author hvillarreal
 *
 */
import BaseView from 'BaseView';

export default BaseView.extend({
	el: '#js_messageView',

	events: {
		// Free text search
		'click .js_freeTextSearch-close': 'removeFreeTextSearch',

		// Currency filter
		'click .js_currencySelector-close': 'removeCurrencyFilter',
		'keyup .js_currencySelector-close': 'removeCurrencyFilter',

		// Transaction type
		'click .js_filter-close': 'removeFilterSelection',
		'keyup .js_filter-close': 'removeFilterSelection',

	},

	initialize(options) {
		// get visibility of our parent (filter view) so we can have access to
		// 'onFilterView' since we rely on it heavily
		this.filterView = options.parent;

		this.render();
	},

	/**
	 * Remove free text search from the model and reinitiate the search.
	 * This gets triggered when user clicks close icon in oval icon.
	 */
	removeFreeTextSearch (event) {
		// delegate job to the free text search view
		this.filterView.freeTextSearchView.removeFreeTextSearch(event);
	},

	/**
	 * Remove selected currency filter from the model and reinitiate the search
	 */
	removeCurrencyFilter (event) {
		if (event.keyCode && event.keyCode === 13 || !event.keyCode) {
			this.model.set('isClearFreeTextSearch', true);
			this.model.set('isClientSideFiltering', true);
			this.model.set('selectedCurrency', 'ALL');

			this.filterView.onFilterView(event);
		}
	},

	/**
	 * Remove filter selection.
	 */
	removeFilterSelection (event) {
		if (event.keyCode && event.keyCode === 13 || !event.keyCode) {
			this.removeFilterValue(event);
			this.filterView.onFilterView(event);
		}
	},

	/**
	 * Remove the selected filter from the model and reinitiate the search
	 */
	removeFilterValue (event) {
		let txnFilter = this.model.get('transactionFilter');
		this.model.set('isClientSideFiltering', true);
		this.model.set('isClearFilterSelection', true);
		this.model.unset('transactionFilter');
		this.model.triggerTxnFilterFPTI(txnFilter, false);
	}

});



// WEBPACK FOOTER //
// ./view/activity/filters/filterTagsView.es6